// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-js": function componentSrcPagesAboutJs() {
    return import("./../../src/pages/about.js"
    /* webpackChunkName: "component---src-pages-about-js" */
    );
  },
  "component---src-pages-contact-js": function componentSrcPagesContactJs() {
    return import("./../../src/pages/contact.js"
    /* webpackChunkName: "component---src-pages-contact-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-posts-10-common-a-11-y-mistakes-mdx": function componentSrcPosts10CommonA11YMistakesMdx() {
    return import("./../../src/posts/10-common-a11y-mistakes.mdx"
    /* webpackChunkName: "component---src-posts-10-common-a-11-y-mistakes-mdx" */
    );
  },
  "component---src-posts-accessible-dropdown-navigation-mdx": function componentSrcPostsAccessibleDropdownNavigationMdx() {
    return import("./../../src/posts/accessible-dropdown-navigation.mdx"
    /* webpackChunkName: "component---src-posts-accessible-dropdown-navigation-mdx" */
    );
  },
  "component---src-posts-accessible-form-mdx": function componentSrcPostsAccessibleFormMdx() {
    return import("./../../src/posts/accessible-form.mdx"
    /* webpackChunkName: "component---src-posts-accessible-form-mdx" */
    );
  },
  "component---src-posts-accessible-neumorphism-mdx": function componentSrcPostsAccessibleNeumorphismMdx() {
    return import("./../../src/posts/accessible-neumorphism.mdx"
    /* webpackChunkName: "component---src-posts-accessible-neumorphism-mdx" */
    );
  },
  "component---src-posts-inclusivity-in-video-conferencing-mdx": function componentSrcPostsInclusivityInVideoConferencingMdx() {
    return import("./../../src/posts/inclusivity-in-video-conferencing.mdx"
    /* webpackChunkName: "component---src-posts-inclusivity-in-video-conferencing-mdx" */
    );
  },
  "component---src-posts-neumorphism-mdx": function componentSrcPostsNeumorphismMdx() {
    return import("./../../src/posts/neumorphism.mdx"
    /* webpackChunkName: "component---src-posts-neumorphism-mdx" */
    );
  },
  "component---src-posts-visually-hidden-mdx": function componentSrcPostsVisuallyHiddenMdx() {
    return import("./../../src/posts/visually-hidden.mdx"
    /* webpackChunkName: "component---src-posts-visually-hidden-mdx" */
    );
  }
};